import {
  collection,
  doc,
  getDoc,
  getDocs,
  setDoc,
  deleteDoc,
  serverTimestamp,
  
} from "firebase/firestore";
import { db, auth, storage } from "../firebase/firebase";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import {  signInWithEmailAndPassword } from "firebase/auth";

import { toast } from "react-toastify";

//get blogs by id
export const getBlogById = async (blogId) => {
  try {
    const blogRef = doc(db, "blogs", blogId);
    const blogSnap = await getDoc(blogRef);
    if (blogSnap.exists()) return blogSnap.data();
    throw new Error("Blog not found");
  } catch (error) {
    console.error("Error fetching blog:", error);
    throw error;
  }
};

// get all bloggers
export const getAllBloggers = async () => {
  try {
    const usersCollection = collection(db, "users");
    const snapshot = await getDocs(usersCollection);
    return snapshot.docs.map((doc) => doc.data().firstName);
  } catch (error) {
    console.error("Error fetching bloggers:", error);
    throw error;
  }
};

// get all blogs filter type
export const getAllTypes = async () => {
  try {
    const usersCollection = collection(db, "blogFilters");
    const snapshot = await getDocs(usersCollection);
    return snapshot.docs.map((doc) => doc.data().title);
  } catch (error) {
    console.error("Error fetching types:", error);
    throw error;
  }
};

// add blog
export const createBlog = async (newBlog, blogId) => {
  try {
    const blogRef = doc(db, "blogs", blogId);
    await setDoc(blogRef, {
      ...newBlog,
      id: blogId,
      updatedAt: serverTimestamp(),
    });
    toast("Blog added successfully!");
    return blogId;
  } catch (error) {
    console.error("Error adding blog:", error);
    toast.error("Failed to add blog.");
  }
};

//edit blog
export const editBlog = async (
  blogId,
  updatedBlog,
  blogImageFile = null,
  bloggerImageFile = null
) => {
  try {
    if (blogImageFile) {
      const blogImageRef = ref(storage, `blogImages/${blogId}`);
      await uploadBytes(blogImageRef, blogImageFile);
      updatedBlog.blogImage = await getDownloadURL(blogImageRef);
    }
    if (bloggerImageFile) {
      const bloggerImageRef = ref(storage, `bloggerImages/${blogId}`);
      await uploadBytes(bloggerImageRef, bloggerImageFile);
      updatedBlog.bloggerImage = await getDownloadURL(bloggerImageRef);
    }
    const blogRef = doc(db, "blogs", blogId);
    await setDoc(
      blogRef,
      { ...updatedBlog, updatedAt: serverTimestamp() },
      { merge: true }
    );
    toast("Blog updated successfully!");
  } catch (error) {
    console.error("Error updating blog:", error);
    throw new Error("Failed to update blog");
  }
};

//upload title blog image
export const uploadImage = async (file, blogId) => {
  try {
    const imageRef = ref(storage, `blogImages/${blogId}`);
    await uploadBytes(imageRef, file);
    return await getDownloadURL(imageRef);
  } catch (error) {
    console.error("Error uploading image:", error);
    throw new Error("Failed to upload image");
  }
};

//upload blogger Image
export const uploadBloggerImage = async (file, blogId) => {
  try {
    const imageRef = ref(storage, `bloggerImages/${blogId}`);
    await uploadBytes(imageRef, file);
    return await getDownloadURL(imageRef);
  } catch (error) {
    console.error("Error uploading image:", error);
    throw new Error("Failed to upload image");
  }
};

//delete blog
export const deleteBlog = async (blogId) => {
  try {
    await deleteDoc(doc(db, "blogs", blogId));
    toast("Blog deleted successfully!");
  } catch (error) {
    console.error("Error deleting blog:", error);
    toast.error("Failed to delete blog");
  }
};

export const getAllBlogs = async () => {
  const blogsCollection = collection(db, "blogs");
  const blogSnapshot = await getDocs(blogsCollection);
  const blogList = blogSnapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));

  return blogList;
};

export const signIn = async (email, password, designation) => {
  try {
    const res = await signInWithEmailAndPassword(auth, email, password);
    const userDoc = await getDoc(doc(db, "users", res.user.uid));

    if (!userDoc.exists()) {
      toast("User does not exist in the database.");
      auth.signOut();
      return null;
    }

    const user = userDoc.data();

    if (!user.designation) {
      toast("User designation is missing.");
      auth.signOut();
      return null;
    }

    if (user.designation !== designation) {
      toast("User is not valid for this role.");
      auth.signOut();
      return null;
    }

    return user;
  } catch (error) {
    console.error("Error in sign in:", error.message);
    toast(error.message);
  }
};
